import React from "react";

// MUI Grid
import { GridRenderCellParams } from "@mui/x-data-grid";

// MUI
import Box from "@mui/material/Box";
import { Tooltip } from "@mui/material";
// import Link from "@mui/material/Link";

// Utils
import { displayDateFormart } from "../../../utility/utils";

function ExpandableCell({ value }: GridRenderCellParams) {
  const sliceValue = 45;
  return (
    <Tooltip title={value} placement="top-start">
      <Box>
        <>
          {value.slice(0, sliceValue)} {<span>...</span>}
        </>

        {/* {expanded ? value : value.slice(0, sliceValue)}&nbsp;
        {value.length > sliceValue && (
          <Link
            type="button"
            component="button"
            sx={{ fontSize: "inherit" }}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? "view less" : "view more"}
          </Link>
          
        )} */}
      </Box>
    </Tooltip>
  );
}

const ReportingColumns = [
  {
    field: "projectId",
    type: "number",
    width: 80,
    headerName: "Project ID",
  },
  {
    field: "projectName",
    type: "string",
    width: 250,
    headerName: "Project Name",
    renderCell: (params: GridRenderCellParams) => (
      <ExpandableCell {...params} />
    ),
  },
  {
    field: "userName",
    type: "string",
    width: 150,
    headerName: "Created By",
  },
  {
    field: "csgo",
    type: "string",
    width: 150,
    headerName: "CSGO",
  },
  {
    field: "sbg",
    type: "string",
    width: 150,
    headerName: "SBG",
  },
  {
    field: "sbu",
    type: "string",
    width: 150,
    headerName: "SBU",
  },
  {
    field: "bu",
    type: "string",
    width: 150,
    headerName: "BU",
  },
  {
    field: "segmentLob",
    type: "string",
    width: 180,
    headerName: "Segment LOB",
  },
  {
    field: "segmentClassification",
    type: "string",
    width: 170,
    headerName: "Segment Classification",
  },
  {
    field: "isGreenListCustomer",
    type: "string",
    width: 120,
    headerName: "Green Customer",
  },
  {
    field: "isBaseLoad",
    type: "string",
    width: 100,
    headerName: "Base Load",
  },
  {
    field: "assessCustomerRating",
    type: "string",
    width: 180,
    headerName: "Assess Rating",
    renderCell: (params: GridRenderCellParams) => (
      <ExpandableCell {...params} />
    ),
  },
  {
    field: "briefScope",
    type: "string",
    width: 180,
    headerName: "Brief Scope",
    renderCell: (params: GridRenderCellParams) => (
      <ExpandableCell {...params} />
    ),
  },
  {
    field: "estimatedValue",
    type: "number",
    width: 120,
    headerName: "Estimated value (INR Cr)",
  },
  {
    field: "valueSlab",
    type: "string",
    width: 150,
    headerName: "Value Slab",
  },
  // {
  //   field: "isNewProcessApplicable",
  //   type: "string",
  //   width: 180,
  //   headerName: "New Process Applicable",
  // },
  {
    field: "preBidExpenses",
    type: "number",
    width: 150,
    headerName: "Pre Bid Expenses",
  },
  {
    field: "isPriceVariation",
    type: "string",
    width: 120,
    headerName: "Price Variation",
  },
  {
    field: "isPqrequired",
    type: "string",
    width: 100,
    headerName: "PQ Required",
  },
  {
    field: "preQualificationRequirement",
    type: "string",
    width: 150,
    headerName: "PQ Requirement",
  },
  {
    field: "isJvpartnerRequired",
    type: "string",
    width: 150,
    headerName: "JV Partner Required",
  },
  {
    field: "jvpartnerSuggestedName",
    type: "string",
    width: 180,
    headerName: "JV Partner Suggested Name",
  },
  {
    field: "isTechPartnerRequired",
    type: "string",
    width: 150,
    headerName: "Tech Partner Required",
  },
  {
    field: "techPartnerSuggestedName",
    type: "string",
    width: 180,
    headerName: "Tech Partner Suggested Name",
  },
  {
    field: "winProbabilityPercentage",
    type: "string",
    width: 150,
    headerName: "Go-Get Factor(%)",
    valueGetter: ({ value }: any) => {
      return value && value.toFixed(2);
    },
  },
  {
    field: "goFactorPercentage",
    type: "string",
    width: 120,
    headerName: "Go Factor(%)",
    valueGetter: ({ value }: any) => {
      return value && value.toFixed(2);
    },
  },
  {
    field: "getFactorPercentage",
    type: "string",
    width: 120,
    headerName: "Get Factor(%)",
    valueGetter: ({ value }: any) => {
      return value && value.toFixed(2);
    },
  },
  {
    field: "manualGoGetFactorPercentage",
    type: "string",
    width: 180,
    headerName: "Manual Go-Get Factor(%)",
    valueGetter: ({ value }: any) => {
      return value && value.toFixed(2);
    },
  },
  {
    field: "manualGoFactorPercentage",
    type: "string",
    width: 150,
    headerName: "Manual Go Factor(%)",
    valueGetter: ({ value }: any) => {
      return value && value.toFixed(2);
    },
  },
  {
    field: "manualGetFactorPercentage",
    type: "string",
    width: 160,
    headerName: "Manual Get Factor(%)",
    valueGetter: ({ value }: any) => {
      return value && value.toFixed(2);
    },
  },
  {
    field: "manualGoGetFactorRemarks",
    type: "string",
    width: 180,
    headerName: "Manual Go-Get Factor Remarks",
  },
  {
    field: "tenderExpectedDate",
    type: "date",
    width: 180,
    headerName: "Tender Expected Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "awardExpectedDate",
    type: "date",
    width: 150,
    headerName: "Award Expected Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "projectDuration",
    type: "number",
    width: 150,
    headerName: "Project Duration",
  },
  {
    field: "isOM",
    type: "string",
    width: 50,
    headerName: "OM",
  },
  {
    field: "omduration",
    type: "number",
    width: 100,
    headerName: "OM Duration",
  },
  {
    field: "estimatedTimeToBid",
    type: "number",
    width: 180,
    headerName: "Estimated Time To Bid",
  },
  {
    field: "environmentClearanceStatus",
    type: "string",
    width: 180,
    headerName: "Environment Clearence Status",
    renderCell: (params: GridRenderCellParams) => (
      <ExpandableCell {...params} />
    ),
  },
  {
    field: "country",
    type: "string",
    width: 120,
    headerName: "Country",
  },
  {
    field: "state",
    type: "string",
    width: 120,
    headerName: "State",
  },
  {
    field: "city",
    type: "string",
    width: 120,
    headerName: "City",
  },
  {
    field: "location",
    type: "string",
    width: 150,
    headerName: "Location",
  },
  {
    field: "isLicenseRequired",
    type: "string",
    width: 150,
    headerName: "Licence Required",
  },
  {
    field: "licenseProcurementNextSteps",
    type: "string",
    width: 180,
    headerName: "Licence Procurement Next Steps",
  },
  {
    field: "rowstatus",
    type: "string",
    width: 180,
    headerName: "ROW Status",
    renderCell: (params: GridRenderCellParams) => (
      <ExpandableCell {...params} />
    ),
  },
  {
    field: "tenderMaturity",
    type: "string",
    width: 120,
    headerName: "Tender Maturity",
  },
  {
    field: "expectedCompetitors",
    type: "string",
    width: 180,
    headerName: "Expected Competitors",
    renderCell: (params: GridRenderCellParams) => (
      <ExpandableCell {...params} />
    ),
  },
  {
    field: "additionalInformation",
    type: "string",
    width: 180,
    headerName: "Additional Information",
    renderCell: (params: GridRenderCellParams) => (
      <ExpandableCell {...params} />
    ),
  },
  {
    field: "createdDate",
    type: "date",
    width: 150,
    headerName: "Created Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "contractType",
    type: "string",
    width: 150,
    headerName: "Contract Type",
  },
  {
    field: "otherContractType",
    type: "string",
    width: 150,
    headerName: "Other Contract Type",
  },
  {
    field: "customerName",
    type: "string",
    width: 150,
    headerName: "Customer Name",
  },
  {
    field: "geography",
    type: "string",
    width: 120,
    headerName: "Geography",
  },
  {
    field: "competitionIntensity",
    type: "string",
    width: 150,
    headerName: "Competition Intensity",
  },
  {
    field: "proposalStage",
    type: "string",
    width: 150,
    headerName: "Proposal Stage",
  },
  {
    field: "competitorsWithClient",
    type: "string",
    width: 150,
    headerName: "Competitors executing work with client",
  },
  {
    field: "winStrategyAndValueProposition",
    type: "string",
    width: 150,
    headerName: "Win strategy and value proposition",
  },
  {
    field: "countryCorruptionRating",
    type: "string",
    width: 150,
    headerName: "Country corruption rating (TCPI)",
  },
  {
    field: "tenderingBandwidth",
    type: "string",
    width: 150,
    headerName: "Tendering Bandwidth",
  },
  {
    field: "fundingSource",
    type: "string",
    width: 150,
    headerName: "Funding Source",
  },
  {
    field: "otherFundingSource",
    type: "string",
    width: 180,
    headerName: "Other Funding Source",
  },
  {
    field: "projectOverallWinLossStatus",
    type: "string",
    width: 150,
    headerName: "Win-Loss Status",
  },
  {
    field: "bidManagerName",
    type: "string",
    width: 150,
    headerName: "Bid Manager Name",
  },
  {
    field: "isNewTeprocessCommenced",
    type: "string",
    width: 180,
    headerName: "New TE Process Commenced",
  },
  {
    field: "isWorkStarted",
    type: "string",
    width: 150,
    headerName: "Work Started",
  },
  {
    field: "bidExploratoryStatus",
    type: "string",
    width: 150,
    headerName: "Exploratory Bid",
  },
  {
    field: "bidSubmissionDate",
    type: "date",
    width: 150,
    headerName: "Bid Submission Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "opportunityQualification",
    type: "string",
    width: 180,
    headerName: "Opportunity Qualification",
  },
  {
    field: "isBidDropped",
    type: "string",
    width: 120,
    headerName: "Bid Dropped",
  },
  {
    field: "priority",
    type: "string",
    width: 100,
    headerName: "Priority",
  },
  {
    field: "timeToPQDays",
    type: "string",
    width: 100,
    headerName: "Time to PQ (Days)",
  },
  {
    field: "pbt",
    type: "number",
    width: 100,
    headerName: "PBT (INR Cr)",
  },
  {
    field: "oh",
    type: "number",
    width: 100,
    headerName: "OH (INR Cr)",
  },
  {
    field: "projectMargin",
    type: "number",
    width: 100,
    headerName: "Project Margin (INR Cr)",
  },
  {
    field: "financeCost",
    type: "number",
    width: 100,
    headerName: "Finance cost (INR Cr)",
  },
  {
    field: "depreciation",
    type: "number",
    width: 100,
    headerName: "Depreciation (INR Cr)",
  },
  {
    field: "grossMargin",
    type: "number",
    width: 100,
    headerName: "Gross Margin (INR Cr)",
  },
  {
    field: "normalContingency",
    type: "number",
    width: 100,
    headerName: "Normal contingency (INR Cr)",
  },
  {
    field: "specialContingency",
    type: "number",
    width: 100,
    headerName: "Special contingency (INR Cr)",
  },
  {
    field: "isSavedAsDraft",
    type: "string",
    width: 150,
    headerName: "Saved As Draft",
  },
  {
    field: "savedAsDraftDate",
    type: "date",
    width: 150,
    headerName: "Saved As Draft Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "isDrafted",
    type: "string",
    width: 100,
    headerName: "Drafted",
  },
  {
    field: "draftedDate",
    type: "date",
    width: 150,
    headerName: "Drafted Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "isSubmitted",
    type: "string",
    width: 100,
    headerName: "Submitted",
  },
  {
    field: "submittedDate",
    type: "date",
    width: 150,
    headerName: "Submitted Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "isBuapproved",
    type: "string",
    width: 100,
    headerName: "BU Approved",
  },
  {
    field: "buapprovedDate",
    type: "date",
    width: 150,
    headerName: "BU Approved Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "buapprovedComment",
    type: "string",
    width: 100,
    headerName: "BU Approved Comment",
  },
  {
    field: "isBuonHold",
    type: "string",
    width: 100,
    headerName: "BU On-Hold",
  },
  {
    field: "buonHoldDate",
    type: "date",
    width: 150,
    headerName: "BU On-Hold Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "isSbuapproved",
    type: "string",
    width: 120,
    headerName: "SBU Approved",
  },
  {
    field: "sbuapprovedDate",
    type: "date",
    width: 150,
    headerName: "SBU Approved Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "sbuapprovedComment",
    type: "string",
    width: 120,
    headerName: "SBU Approved Comment",
  },
  {
    field: "isSbuonHold",
    type: "string",
    width: 100,
    headerName: "SBU On-Hold",
  },
  {
    field: "sbuonHoldDate",
    type: "date",
    width: 150,
    headerName: "SBU On-Hold Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "isSbgapproved",
    type: "string",
    width: 120,
    headerName: "SBG Approved",
  },
  {
    field: "sbgapprovedDate",
    type: "date",
    width: 150,
    headerName: "SBG Approved Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "sbgapprovedComment",
    type: "string",
    width: 120,
    headerName: "SBG Approved Comment",
  },
  {
    field: "isSbgonHold",
    type: "string",
    width: 100,
    headerName: "SBG On-Hold",
  },
  {
    field: "sbgonHoldDate",
    type: "date",
    width: 150,
    headerName: "SBG On-Hold Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "isCsgoapproved",
    type: "string",
    width: 150,
    headerName: "CSGO Approved",
  },
  {
    field: "csgoapprovedDate",
    type: "date",
    width: 180,
    headerName: "CSGO Approved Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "csgoapprovedComment",
    type: "string",
    width: 150,
    headerName: "CSGO Approved Comment",
  },
  {
    field: "isCsgoonHold",
    type: "string",
    width: 150,
    headerName: "CSGO On-Hold",
  },
  {
    field: "csgoonHoldDate",
    type: "date",
    width: 180,
    headerName: "CSGO On-Hold Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "isRejected",
    type: "string",
    width: 100,
    headerName: "Rejected",
  },
  {
    field: "rejectedDate",
    type: "date",
    width: 150,
    headerName: "Rejected Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "rejectedComment",
    type: "string",
    width: 100,
    headerName: "Rejected Comment",
  },
];

export default ReportingColumns;
